var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollectbookTag04(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 16,
    viewBox: "0 0 43 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_collectbook_tag_04",
    clipPath: "url(#clip0_2496_32279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5459 0.727273C4.52928 0.727273 1.27317 3.98338 1.27317 8C1.27317 12.0166 4.52928 15.2727 8.5459 15.2727H34.7277C38.7443 15.2727 42.0004 12.0166 42.0004 8C42.0004 3.98338 38.7443 0.727273 34.7277 0.727273H8.5459ZM0.545898 8C0.545898 3.58172 4.12762 0 8.5459 0H34.7277C39.146 0 42.7277 3.58172 42.7277 8C42.7277 12.4183 39.146 16 34.7277 16H8.5459C4.12762 16 0.545898 12.4183 0.545898 8Z",
    fill: "#938F8F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7993 4.32016V5.20614H13.0082V7.8606C13.402 7.82895 13.7852 7.79379 14.1544 7.74809L14.2318 8.56727C12.4246 8.86611 10.3538 8.90128 8.83497 8.89776L8.71191 8.00474C9.03536 8.00474 9.38343 8.00122 9.74908 7.9942V5.20614H8.95802V4.32016H13.7993ZM10.069 12.3468V9.52709H11.1695V11.4502H16.1795V12.3468H10.069ZM10.8179 7.97309C11.1871 7.96255 11.5632 7.94848 11.9394 7.92739V5.20614H10.8179V7.97309ZM14.7169 10.1564V3.54316H15.8279V6.13784H17.0831V7.05898H15.8279V10.1564H14.7169ZM22.1455 4.3061V5.20966H19.0234V6.81639H21.9909V7.69183H19.0234V9.54467C20.4122 9.53412 21.4915 9.47786 22.7431 9.27395L22.8451 10.1705C21.4669 10.3885 20.2575 10.4307 18.6437 10.4377H17.9055V4.3061H22.1455ZM23.4674 12.5155V3.53613H24.5749V7.00976H25.9602V7.93794H24.5749V12.5155H23.4674ZM29.7287 6.08511C29.7287 7.56175 30.5936 9.11222 32.0386 9.71695L31.4374 10.5889C30.3756 10.1283 29.5951 9.18605 29.1837 8.04342C28.7724 9.27747 27.9849 10.3146 26.9302 10.8139L26.2938 9.94195C27.7142 9.29154 28.5967 7.61799 28.6037 6.08511V5.32919H26.6243V4.42213H31.6905V5.32919H29.7287V6.08511ZM32.6997 12.5155V3.53613H33.8141V12.5155H32.6997Z",
    fill: "#938F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2496_32279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1818,
    height: 16,
    fill: "white",
    transform: "translate(0.545898)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollectbookTag04);
export default __webpack_public_path__ + "static/media/icon_collectbook_tag_04.c8665e24848d2cc0e18c7488bd2bb415.svg";
export { ForwardRef as ReactComponent };